import {reader} from "messaging/reader.js";

export const getSlicedParameters = (slicer, parameters, args) => {
    let ratio = args[4];
    return slicer(parameters, ratio, args[5], args[3]);
};

let id = 0;
export const sliceParams = () => {
    const _id = ++id;
    let counter=0;
    const _reader = reader("planarReset");
    return (coords, ratio, effect, history) => {
        if (_reader().some(
            x => x === effect.id)) {
            counter=0;
        }
        counter++;
        let _parameters = Object.keys(history[0]);
        let numParameters = Math.round(ratio * _parameters.length);
        let start = (counter*numParameters) % _parameters.length;
        let end = start + numParameters;
        let parameterKeys = _parameters.slice(start, start + numParameters);
        if (parameterKeys.length < numParameters) {
            end += numParameters - parameterKeys.length;
            parameterKeys = [... parameterKeys, ... _parameters.slice(0, numParameters - parameterKeys.length)];
        }
        let parameterCoords = {};
        parameterKeys.forEach(
            key => {
                if (coords[key]) {
                    parameterCoords[key]= coords[key];// || history[0][key];
                }
            });
        return parameterCoords;
    };
};
